/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import Icon from "../components/ui/Icon";
import InfoCard from "../components/ui/InfoCard";
import AppLoader from "../components/ui/AppLoader";
import { InputField, TextAreaField } from "../components/ui/Field";
import { getOrgId } from "../utils/authHelpers";
import {
  getOrganizationByID,
  updateOrganizationById,
} from "../api/organizations";

export function BusinessDetailsPage({
  // data,
  // onChange,
  notify,
  setCurrentPage,
}) {
  const [formState, setFormState] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const organizationId = getOrgId();
  console.debug(organizationId, "organizationId");
  const fetchOrganizationData = async () => {
    setIsFetching(true);
    try {
      if (organizationId) {
        const organizationData = await getOrganizationByID(organizationId);
        console.log("Organization data:", organizationData);

        setFormState({
          company: {
            name: organizationData?.name || "",
            industry: organizationData?.industry || "",
            description: organizationData?.meta_data?.description || "",
          },
          address: {
            street: organizationData?.meta_data?.address?.street || "",
            city: organizationData?.meta_data?.address?.city || "",
            state: organizationData?.meta_data?.address?.state || "",
            zip: organizationData?.meta_data?.address?.zip || "",
          },
          contact: {
            phone: organizationData?.meta_data?.contact?.phone || "",
            email: organizationData?.meta_data?.contact?.email || "",
            website: organizationData?.meta_data?.contact?.website || "",
          },
          hours: organizationData?.meta_data?.hours || "",
          twilioPhone: organizationData?.twilio_phone_number || "",
          profileNote: organizationData?.profileNote || "",
        });
      }
    } catch (error) {
      console.error("Failed to fetch organization data:", error);
      notify?.({
        tone: "danger",
        title: "Failed to load business details",
        description: error.message || "Unable to fetch organization data.",
      });
    } finally {
      setIsFetching(false);
    }
  };
  useEffect(() => {
    console.count("BusinessDetailsPage effect(fetchOrganizationData) ran");

    fetchOrganizationData();
  }, []);

  const updateSection = (section, field, value) => {
    setFormState((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const updateRoot = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!organizationId) {
      notify?.({
        tone: "danger",
        title: "Organization not found",
        description: "Unable to determine organization ID.",
      });
      return;
    }

    setIsSaving(true);
    try {
      const payload = {
        name: formState.company?.name || "",
        industry: formState.company?.industry || "",
        twilio_phone_number: formState.twilioPhone || "",
        profileNote: formState.profileNote || "",
        meta_data: {
          description: formState.company?.description || "",
          hours: formState.hours || "",
          address: {
            street: formState.address?.street || "",
            city: formState.address?.city || "",
            state: formState.address?.state || "",
            zip: formState.address?.zip || "",
          },
          contact: {
            phone: formState.contact?.phone || "",
            email: formState.contact?.email || "",
            website: formState.contact?.website || "",
          },
        },
      };

      console.log("Updating organization with payload:", payload);

      await updateOrganizationById(organizationId, payload);
      notify?.({
        tone: "success",
        title: "Business details saved",
        description: "Your company profile has been updated successfully.",
      });
    } catch (error) {
      console.error("Update failed:", error);

      notify?.({
        tone: "danger",
        title: "Update failed",
        description:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong while updating.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  console.debug(formState, "formState");
  if (isFetching) {
    return (
      <div className="page">
        <div className="page-header">
          <h1 className="page-title">Business Details</h1>
          <p className="page-subtitle">Manage your company information</p>
        </div>
        <AppLoader
          variant="page"
          label="Loading business details"
          sublabel="Fetching organization profile and contact information..."
        />
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Business Details</h1>
          <p className="page-subtitle">Manage your company information</p>
        </div>
        <div className="page-actions">
          <Button
            loading={isSaving}
            variant="primary"
            iconLeft={<Icon name="save" size={16} />}
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </div>
      </div>

      <div className="split-grid">
        <div className="panel-stack">
          <Card title="Company Information">
            <div className="form-grid">
              <InputField
                label="Company Name"
                value={formState?.company?.name}
                onChange={(event) =>
                  updateSection("company", "name", event.target.value)
                }
              />
              <InputField
                label="Industry"
                value={formState?.company?.industry}
                onChange={(event) =>
                  updateSection("company", "industry", event.target.value)
                }
              />
              <TextAreaField
                label="Description"
                value={formState?.company?.description}
                onChange={(event) =>
                  updateSection("company", "description", event.target.value)
                }
                rows={5}
              />
            </div>
          </Card>

          <Card title="Address">
            <div className="form-grid">
              <InputField
                label="Street Address"
                value={formState?.address?.street}
                onChange={(event) =>
                  updateSection("address", "street", event.target.value)
                }
              />
            </div>
            <div className="form-grid cols-2">
              <InputField
                label="City"
                value={formState?.address?.city}
                onChange={(event) =>
                  updateSection("address", "city", event.target.value)
                }
              />
              <InputField
                label="State"
                value={formState?.address?.state}
                onChange={(event) =>
                  updateSection("address", "state", event.target.value)
                }
              />
            </div>
            <div className="form-grid">
              <InputField
                label="ZIP Code"
                value={formState?.address?.zip}
                onChange={(event) =>
                  updateSection("address", "zip", event.target.value)
                }
              />
            </div>
          </Card>

          <Card title="Contact Information">
            <div className="form-grid">
              <InputField
                label="Phone"
                value={formState?.contact?.phone}
                onChange={(event) =>
                  updateSection("contact", "phone", event.target.value)
                }
              />
              <InputField
                label="Email"
                value={formState?.contact?.email}
                onChange={(event) =>
                  updateSection("contact", "email", event.target.value)
                }
              />
              <InputField
                label="Website"
                value={formState?.contact?.website}
                onChange={(event) =>
                  updateSection("contact", "website", event.target.value)
                }
              />
            </div>
          </Card>
        </div>

        <div className="panel-stack">
          <Card title="Hours of Operation">
            <TextAreaField
              label="Business Hours"
              value={formState?.hours}
              onChange={(event) => updateRoot("hours", event.target.value)}
              rows={4}
            />
          </Card>

          <Card title="Twilio Phone Number">
            <InputField
              label="Phone Number"
              value={formState?.twilioPhone}
              onChange={(event) =>
                updateRoot("twilioPhone", event.target.value)
              }
              hint="This is your main business phone number configured with Twilio for call handling."
            />
          </Card>

          <InfoCard title="Business Profile" icon="building">
            {formState?.profileNote}
          </InfoCard>
        </div>
      </div>
    </div>
  );
}

export default BusinessDetailsPage;
